import ManageSelf from '../components/ManageSelf';
export default ManageSelf; 